<div class="container-fluid" style="padding: 0 1.8rem 1.8rem">
    <h5>Feeder Manager</h5>

    <div class="row">
        <div class="col-md-12">
            <div>
                <div class="example-button-row">
                    <button mat-raised-button color="primary" (click)="openDialog('add','')">Add</button>
                </div>
                <div fxLayout fxLayoutAlign="center center">
                    <mat-form-field fxFlex="40%" style="width: 80%;">
                        <input matInput type="text" (keyup)="doFilter($event.target.value)" placeholder="Search">
                    </mat-form-field>
                </div>
                </div>
        </div>
    </div>
</div>
<ngx-ui-loader></ngx-ui-loader>
<div class="container-fluid" style="padding: 0 1.8rem 1.8rem">
    <div class="row">
        <div class="col-md-12">
          <div>
            <table *ngIf="dataSource" mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
              <ng-container matColumnDef="serialnumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Asset ID </th>
                <td mat-cell *matCellDef="let element"> {{element.serialNo}}({{element.asset_name}}) </td>
              </ng-container>
              <ng-container matColumnDef="sitename">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Site Name </th>
                  <td mat-cell *matCellDef="let element"> {{element.sitename}} </td>
                </ng-container>
              <ng-container matColumnDef="deviceId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Device ID </th>
                <td mat-cell *matCellDef="let element"> {{element.device_id}} </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Actions </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-icon-button color="primary" (click)="openDialog('update',element)">
                        <mat-icon class="mat-18">edit</mat-icon>
                    </button>
                  <button *ngIf="roleID == 1" mat-icon-button color="warn" (click)="deletSolarManager(element)">
                    <mat-icon class="mat-18">delete</mat-icon>
                </button>
                  <!-- <span class="material-icons" (click)="deleteData(element.serialnumber)">
                    delete
                    </span> -->                 
<!--
                    <span mat-icon-button color="blue" (click)="editData(element.serialnumber)">
                      edit
                      </span> -->
                      <!-- <span class="material-icons" (click)="fetchDetails(element.serialnumber)">
                        info
                        </span> -->
                </td>

              </ng-container>

              

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons></mat-paginator>
          </div>
        </div>

    </div>
    </div>
